// Global Enums
import {
  webPages,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  scrollTop,
} from '@vroskus/library-helpers/dist/browser';

// Components
import Page from '../../layout/Page';
import Loader from '../../layout/Loader';
import ListSection from '../../sections/RegionsPageSections/ListSection';

// Types
type $Props = Record<string, never>;

type $State = {
  initialised: boolean;
};

class RegionsPageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      initialised: false,
    };
  }

  componentDidMount(): void {
    this.init();
  }

  async init(): Promise<void> {
    try {
      scrollTop();

      this.setState({
        initialised: true,
      });
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  render() {
    const {
      initialised,
    } = this.state;

    return (
      <Page
        id={webPages.regionsPage}
        tags={{
          title: 'Regions',
        }}
      >
        <Loader loading={!initialised}>
          <div className={'max-w-sm mx-auto'}>
            <ListSection />
          </div>
        </Loader>
      </Page>
    );
  }
}

export default RegionsPageView;
